import { isMaxDaresReachedByPlatform } from 'root/src/client/logic/dropEvent/hooks/useIsMaxDaresReached';
import { calculateMaxDaresByPlatform, } from 'root/src/shared/util/calculateMaxDares';
import { useUserCreatorData } from 'root/src/client/logic/auth/hooks/useUser';
import { useDropEvent, useUserCampaignData, } from 'root/src/client/logic/dropEvent/hooks/useDropEvent';
// Find the best platform that hasn't reached max dares by recursion
export function useBestAvailablePlatformToken(dropEvent) {
    var _a;
    const { averageCcv, tokens, averageYoutubeViews, averageYoutubeShortsViews, averageTikTokViews, } = useUserCreatorData();
    const userCampaignData = useUserCampaignData();
    const campaign = (_a = useDropEvent()) !== null && _a !== void 0 ? _a : dropEvent;
    if (!campaign) {
        return null;
    }
    return getBestPlatformToken({
        campaign,
        tokens,
        userCampaignData,
        averageCcv: averageCcv || 0,
        averageYoutubeViews: averageYoutubeViews || 0,
        averageYoutubeShortsViews: averageYoutubeShortsViews || 0,
        averageTikTokViews: averageTikTokViews || 0,
    });
}
/**
 * Find the best platform that hasn't reached max dares
 * By default, it will sort by preferred platform first, then by max dares in descending order
 * If no platform is found, it will return null
 */
export function getBestPlatformToken({ campaign, averageCcv, tokens, userCampaignData, averageYoutubeViews, averageTikTokViews, averageYoutubeShortsViews, }) {
    var _a;
    const choices = tokens === null || tokens === void 0 ? void 0 : tokens.map((token) => {
        const maxDares = calculateMaxDaresByPlatform({
            platform: token.platform,
            campaign,
            averageYoutubeViews,
            averageYoutubeShortsViews,
            averageTikTokViews,
            averageCcv,
        });
        const isMaxDaresReached = isMaxDaresReachedByPlatform({
            maxDares, platform: token.platform, dropEvent: campaign, userCampaignData,
        });
        return { token, maxDares, isMaxDaresReached };
    }).sort((a, b) => {
        // Sort by preferred platform first
        if (a.token.isPreferred) {
            return -1;
        }
        if (b.token.isPreferred) {
            return 1;
        }
        // Sort by max dares in descending order
        return b.maxDares - a.maxDares;
    });
    // Find the first choice that hasn't reached max dares yet
    const matchedChoice = (_a = choices === null || choices === void 0 ? void 0 : choices.find((choice) => {
        return choice.maxDares > 0 && !choice.isMaxDaresReached;
    })) === null || _a === void 0 ? void 0 : _a.token;
    // If no choice is found, return null
    if (!matchedChoice) {
        return null;
    }
    // If the choice is found, return the token
    return matchedChoice;
}
